module.exports = __webpack_public_path__ + "img/conexa.vc.f405f0dc.svg";